import { PORTFOLIO_GROUPS } from "@/lib/data";

/**
 * Portfolio logos grouped by parent network, displayed in uniform white boxes.
 * Linkable={true} opens the brand site in a new tab.
 */
function logoClass(logo) {
  if (logo.boost) return "max-h-14 scale-[2.4] sm:scale-[3] lg:scale-[4] origin-center";
  if (logo.shrink) return "max-h-11";
  return "max-h-14";
}

export default function PortfolioGroups({ linkable = false }) {
  return (
    <div className="space-y-10" data-testid="portfolio-groups">
      {PORTFOLIO_GROUPS.map((group, gi) => {
        const logos = group.brands.flatMap((b) => b.logos || []);

        return (
          <div key={group.name} data-testid={`portfolio-group-${gi}`}>
            <p
              className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] mb-4"
              style={{ color: "var(--zt-navy)" }}
            >
              {group.name}:
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {logos.map((logo, li) => {
                const testId = `portfolio-logo-${gi}-${li}`;
                const tile = (
                  <div className="bg-white border border-slate-200 h-24 flex items-center justify-center p-4 transition-all hover:shadow-[0_8px_24px_rgba(15,23,42,0.08)] hover:border-slate-300 overflow-hidden">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className={`${logoClass(logo)} max-w-full w-auto h-auto object-contain`}
                      loading="lazy"
                    />
                  </div>
                );

                if (linkable && logo.href) {
                  return (
                    <a
                      key={logo.src}
                      href={logo.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={testId}
                      aria-label={logo.alt}
                      className="block group/logo"
                    >
                      {tile}
                    </a>
                  );
                }

                return (
                  <div key={logo.src} data-testid={testId} className="group/logo">
                    {tile}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
